import { createContext, useContext } from 'react'

import { ConnectionState } from 'agora-rtc-react'
import { AgoraCloudProxyMode } from 'src/lib/gql-client'

export type RoomStatus = 'ready' | 'joining' | 'left'
export type ProxyStatus = 'idle' | 'connecting' | 'connected'

type VideoCallRoomContextType = {
  roomStatus: RoomStatus
  connectionState: ConnectionState
  isForcedExitByOtherDevice: boolean
  videoCallRoomUid: string
  videoCallUserUid: number | null
  proxyStatus: ProxyStatus
  agoraCloudProxyMode: AgoraCloudProxyMode
  join: () => void
  leave: () => void
}

export const VideoCallRoomContext = createContext<
  VideoCallRoomContextType | undefined
>(undefined)

export const useVideoCallRoom = () => {
  const context = useContext(VideoCallRoomContext)
  if (!context) {
    throw new Error(
      'useVideoCallRoom must be used within VideoCallRoomProvider',
    )
  }
  return context
}
